import Icon from "@/components/icon/Icon"
import { CustomIconType, RemixIconType } from "@/types/components/icon"
import { getImagePath } from "@/utils/image"

export default function ImageFallback({
  image,
  iconType,
  size,
  alt,
  onClick,
}: {
  iconType: CustomIconType | RemixIconType
  size: number
  image?: string
  alt?: string
  onClick?: () => void
}) {
  if (image) {
    return (
      <img
        src={getImagePath(image)}
        alt={alt ?? "image"}
        width={size}
        height={size}
        onClick={onClick}
        style={{ objectFit: "cover" }}
      />
    )
  } else {
    return (
      <div className="IconCont" onClick={onClick}>
        <Icon type={iconType} width={size} height={size} size={size} />
      </div>
    )
  }
}
